<div class="progress-bar-line" data-cy="progress-bar-line">
  <div class="progress-bar-line-container" data-cy="progress-bar-line-container" [ngStyle]="applyStyle"></div>
  @if (progressBar.dotBackgroundColor != null) {
    <div class="progress-bar-line-container-dot" data-cy="progress-bar-line-container-dot" [style.background]="progressBar.dotBackgroundColor"></div>
  }
</div>
